import React, { useRef, useState } from "react";
import { CSVLink } from "react-csv";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import dayjs from "dayjs";

// Custom.
import { DownloadCsvButtonProps } from "./global";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

// const testHeaders = [
//   { label: "First Name", key: "firstname" },
//   { label: "Last Name", key: "lastname" },
//   { label: "Email", key: "email" },
// ];

// const testData = [
//   { firstname: "Ahmed", lastname: "Tomi", email: "ah@smthing.co.com" },
//   { firstname: "Raed", lastname: "Labes", email: "rl@smthing.co.com" },
//   { firstname: "Yezzi", lastname: "Min l3b", email: "ymin@cocococo.com" },
// ];

const DownloadCsvButton: React.FC<DownloadCsvButtonProps> = (props) => {
  const { filename, headers, data } = props;
  const downloadCsvButton = useRef<any>(null);

  // Show/hide used to force new filename.
  const [showButton, setShowButton] = useState(false);

  const handleDownloadCsv = () => {
    try {
      setShowButton(true);
      setTimeout(() => {
        downloadCsvButton?.current?.link?.click();
        setTimeout(() => {
          setShowButton(false);
        }, 200);
      }, 200);
    } catch (error: any) {
      console.error("error", error);
    }
  };

  const getCsvFilename = () => {
    const name: string[] = [];
    name.push(filename || "csv");
    name.push(dayjs().format("YYYY-MM-DD_HHmmss"));
    return name.join("_");
  };

  return (
    <Box>
      <Fab
        size="medium"
        color="secondary"
        variant="extended"
        onClick={handleDownloadCsv}
        sx={{
          position: "fixed",
          bottom: 16,
          right: 16,
        }}
      >
        <FileDownloadIcon sx={{ mr: 0.5 }} />
        {I18n.get.vocertActions.csv}
      </Fab>
      {showButton && (
        <CSVLink
          ref={downloadCsvButton}
          // headers={testHeaders}
          // data={testData}
          headers={headers}
          data={data}
          filename={getCsvFilename()}
          style={{ height: 0, width: 0 }}
        ></CSVLink>
      )}
    </Box>
  );
};

export default DownloadCsvButton;
